import React from 'react';
import { Loading } from '@brighterionai/br-ui';
import styles from './RouteLoading.css';

const RouteLoading = () => {
    return (
        <div className={styles.landingPage}>
            <div className={styles.spinnerContainer}>
                <Loading size='lg' fillName='orange' />
            </div>
        </div>
    );
};

export default RouteLoading;
